import { render, staticRenderFns } from "./AdminPaymentAdmissions.vue?vue&type=template&id=1d40179b"
import script from "./AdminPaymentAdmissions.vue?vue&type=script&lang=js"
export * from "./AdminPaymentAdmissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports